import { Node } from '@tiptap/core';

/**
 * PageBreakNode — block node that renders as a visible dashed line in the
 * editor and becomes a CSS page-break-before in the generated PDF HTML.
 * In the editor it shows a "Page break" bar with a Remove button, so it can
 * be deleted with one click (a bare 2px line was nearly impossible to select).
 */
export const PageBreakNode = Node.create({
  name: 'pageBreak',
  group: 'block',
  atom: true,
  selectable: true,
  draggable: false,

  renderHTML() {
    return [
      'div',
      {
        class: 'page-break',
        style: 'page-break-before: always; border-top: 2px dashed #ccc; margin: 16px 0; position: relative;',
        'data-type': 'page-break',
      },
    ];
  },

  parseHTML() {
    return [{ tag: 'div[data-type="page-break"]' }, { tag: 'div.page-break' }];
  },

  addNodeView() {
    return ({ editor, getPos }) => {
      const dom = document.createElement('div');
      dom.className = 'page-break-bar';
      dom.contentEditable = 'false';
      const label = document.createElement('span');
      label.textContent = 'Page break — the text below starts on a new page';
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.textContent = '✕ Remove';
      remove.title = 'Remove this page break';
      remove.addEventListener('mousedown', (e) => e.preventDefault());
      remove.addEventListener('click', () => {
        if (!editor.isEditable) return;
        const pos = typeof getPos === 'function' ? getPos() : undefined;
        if (typeof pos !== 'number') return;
        editor.chain().focus().deleteRange({ from: pos, to: pos + 1 }).run();
      });
      dom.append(label, remove);
      return { dom };
    };
  },

  addCommands() {
    return {
      insertPageBreak:
        () =>
        ({ commands }: any) =>
          commands.insertContent({ type: this.name }),
    } as any;
  },
});
